export default __webpack_public_path__ + "ffbd8d2ecedfb86df5cde12fc2060ac6.png";